import styled from '@emotion/styled'

import {
  ACTION_BUTTON_TYPE_EDIT,
  ButtonAction,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Panel,
  PANEL_TOGGLE_TITLE_VARIANT_S,
  PanelToggle,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { editCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { toggleEnabledCallback } from 'Pages/Workflow/recoil/callbacks/step5'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

const StyledText = styled(Text)`
  word-break: break-all;
`

const BoxSetup = () => {
  const intl = useIntl()

  const { Name, Notes, FromName, FromEmail, ReplyTo, FromSms, Enabled } =
    useRecoilValue(workflowDetails)

  const edit = useRecoilCallback(editCallback, [])
  const toggleEnabled = useRecoilCallback(toggleEnabledCallback, [])

  const handleEdit = () => {
    edit(2)
  }

  return (
    <Panel>
      <Flex justifyContent='space-between'>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.AutomationWorkflow.SetupTitle' })}
        </Title>
        <ButtonAction
          type={ACTION_BUTTON_TYPE_EDIT}
          data-mu-test='edit'
          onClick={handleEdit}
        />
      </Flex>

      <SpacingVertical variant={SPACING_24} />

      <Grid cols={12}>
        <GridCell span={6}>
          <Flex columnGap='8px'>
            <FlexItem flex='0 0 auto'>
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.WorkflowName'
                })}
                {': '}
              </Text>
            </FlexItem>
            <StyledText variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {Name || '-'}
            </StyledText>
          </Flex>
        </GridCell>

        <GridCell span={6}>
          <Flex columnGap='8px'>
            <FlexItem flex='0 0 auto'>
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.AutomationWorkflow.Notes' })}
                {': '}
              </Text>
            </FlexItem>

            <StyledText variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {Notes || '-'}
            </StyledText>
          </Flex>
        </GridCell>

        <GridCell span={6}>
          <Flex columnGap='8px'>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({ id: 'Load.AutomationWorkflow.FromName' })}
              {': '}
            </Text>

            <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {FromName || '-'}
            </Text>
          </Flex>
        </GridCell>

        <GridCell span={6}>
          <Flex columnGap='8px'>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({ id: 'Load.AutomationWorkflow.FromEmail' })}
              {': '}
            </Text>

            <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {FromEmail || '-'}
            </Text>
          </Flex>
        </GridCell>

        <GridCell span={6}>
          <Flex columnGap='8px'>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
              {': '}
            </Text>

            <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
              {ReplyTo || '-'}
            </Text>
          </Flex>
        </GridCell>

        {FromSms && (
          <GridCell span={6}>
            <Flex columnGap='8px'>
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.SenderSMS'
                })}
                {': '}
              </Text>

              <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                {FromSms || '-'}
              </Text>
            </Flex>
          </GridCell>
        )}
      </Grid>

      <SpacingVertical variant={SPACING_24} />

      <PanelToggle
        title={intl.formatMessage({
          id: 'Load.AutomationWorkflow.AttivazioneWorkflow'
        })}
        titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
        checked={Enabled}
        onChange={toggleEnabled}
      />
    </Panel>
  )
}

export default BoxSetup
